import React, {Component, Fragment} from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import IframeContainer from './IframeContainer';
import tracker from '../../../../../app/common/utils/tracking/tracker';
import * as trackerConstants from '../../../../../app/common/utils/tracking/tracking.consts';


class Dashboard extends Component {
  componentDidMount() {
    tracker.onPageLoaded(trackerConstants.PAGE_TYPE_MAIN_DASHBOARD);
  }
  render() {
    const {url, contentHeight} = this.props;
    const style = {
      height: `${contentHeight}px`,
      width: '100%',
    };

    return (
      <Fragment>
        <Helmet>
          <title>Como Sense</title>
        </Helmet>
        { url ? <IframeContainer style={style} title="Dashboard" src={url} /> : <div style={style} className="info-container"><h1 className="no-data-message">No data.</h1></div> }
      </Fragment>
    );
  }
}

Dashboard.propTypes = {
  url: PropTypes.string,
  contentHeight: PropTypes.number
};

export default Dashboard;
